// extracted by css-extract-rspack-plugin
module.exports =  {"tab":"ef7cd46240","link":"c70517ca85","tabList":"b31e85d03b","isLoading":"ac7842c666"};